import {ACTION_CODE} from './_actionCode';
import {ExpenseReportService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'GET_ALL_EXPENSE_REPORTS';

export async function getAllExpenseReports(
    userData: Record<string, string>,
    params = "",
    page = 1
) {
    try {
        LoggerService.logInfo('Action - getAllExpenseReports - Start');

        const allExpenseReports = await ExpenseReportService.getAllExpenseReports(userData, params, page);

        const {data, metadata} = allExpenseReports;

        LoggerService.logInfo('Action - getAllExpenseReports - End - Success');

        return ResultModel.newSuccessResult(data, metadata);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllExpenseReports - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
